/*
NOTE: 
1. Use effect for search customer
https://www.udemy.com/course/react-the-complete-guide-incl-redux/learn/lecture/25599220#overview

2. async/await => Promise
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function


*/

import {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import customerServices from "../../services/customerServices";
import orderServices from "../../services/orderServices";
import CustomerAdd from "../Customer/CustomerAdd";
import ModalForForms from "../Modals/ModalForForms";
import customer from "./../../Models/customer";
import OrderRow from "./OrderRow";
// import { Redirect , history} from 'react-router';
import { Routes, Route, useNavigate } from "react-router-dom";
// React Notification
import { NotificationManager } from "react-notifications";
import useTranslation from "./../../customHooks/translations";
import DropdownFromEnum from "../../Utils/DropdownFromEnum";
import { searchTypeEnum } from "./../../enums/enums"; // Import the enum
import _CustomerDetailShow from "./../Customer/_CustomerDetailShow";

import { useSelector, useDispatch } from "react-redux";
import { addCustomerInfo } from "./../../slice/orderSlice";
import CodeTracking from "../../Utils/CodeTracking";
import commonServices from "./../../Utils/commonServices";

const CustomerList = () => {
  const dispatch = useDispatch();
  //Get state from store
  const { customerStore, isLoadingStore } = useSelector((state) => state.order);

  const translation = useTranslation();
  const navigate = useNavigate();
  // (2) Load customer list
  //Customer
  const [enteredSearchField, setEnteredSearchField] = useState("");
  const [customerList, setCustomerList] = useState([]);
  // const [customerObj, setCustomerObj] = useState(null);
  // const [lstOrderDetail, setLstOrderDetail] = useState([]);
  const [selectedSearchStyle_Customer, setSelectedSearchStyle_Customer] =
    useState();
  const [selectedSearchStyle_Order, setSelectedSearchStyle_Order] = useState();
  const [selectedSearchStyle_TrackingNo, setSelectedSearchStyle_TrackingNo] =
    useState();

  const [rowNumber, setRowNumber] = useState(0);
  const customerListHtml = [];
  //Order
  const [customerOrderList, setCustomerOrderList] = useState([]);
  const [customerNameToOrder, setCustomerNameToOrder] = useState("");
  const [lstOrderShowed, setLstOrderShowed] = useState([]);
  const [customerID_ByWhichOrderListed, setCustomerID_ByWhichOrderListed] =
    useState("");
  const [loadingVar, setLoadingVar] = useState(false);
  const [loadingOrderVar, setLoadingOrderVar] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("CUSTOMER");

  // (**) search field value change
  const handleChangeOfSearchField = (e) => {
    setEnteredSearchField(e.target.value);
    console.log("search entered By: " + e.target.value);
  };

  // (**) Show Order detail by CustomerID
  const LoadOrderByCustomerID = async (customerID, customerName) => {
    // alert("Load Order by customer ID: " + customerID);
    setLoadingOrderVar(true);
    setCustomerNameToOrder(customerName);
    setCustomerID_ByWhichOrderListed(customerID);
    console.log("Load Customer Orders-------");
    let customerOrderSearched = await orderServices.getOrderVMByCustomerID(
      customerID
    );
    // debugger;
    console.log(
      "searched Order ----------> " + JSON.stringify(customerOrderSearched)
    );
    setRowNumber(0);
    if (customerOrderSearched == null) {
      setCustomerOrderList([]);
    } else {
      setCustomerOrderList(customerOrderSearched);
    }

    setLoadingOrderVar(false);
  };

  // function resolveAfter2Seconds() {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve("resolved");
  //     }, 2000);
  //   });
  // }

  //NOTE: initial load is keeping commented,
  // as it's taking so much time to show data.
  const firstUpdate = useRef(true);

  useLayoutEffect(() => {
    //** Dont' run for First time */
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    //(1) search
    const identifier = setTimeout(async () => {
      // debugger;
      setLoadingVar(true);

      // NOTE: decide which type search will execute
      //alert("1  => " + selectedSearchType + ",  " + searchTypeEnum.CUSTOMER);
      if (selectedSearchType === searchTypeEnum.CUSTOMER) {
        await onSearch_SetCustomerList();
      } else if (
        selectedSearchType === searchTypeEnum.ORDER ||
        selectedSearchType === searchTypeEnum.TRACKING_NO
      ) {
        // alert("3");
        await onSearch_SetCustomerObjAndOrderList();
      }

      setLoadingVar(false);
      // console.log("customer list ----------> " + customerList.length);
      // console.log("customerListHtml" + customerListHtml);
    }, 1500);

    // 1. Search type - customer
    const onSearch_SetCustomerList = async () => {
      console.log("Load Customer search-------");
      let customerSearched = await customerServices.searchNameOrPhone(
        enteredSearchField
      );
      // debugger;
      console.log("searched customer ----------> " + customerSearched);
      clearAllStateVariable();
      if (customerSearched == null) {
        // setCustomerList([]);
      } else {
        setCustomerList(customerSearched);
      }
    };

    const clearAllStateVariable = () => {
      setRowNumber(0);
      setCustomerList([]);
      dispatch(addCustomerInfo(null));
      setCustomerOrderList([]);
      setCustomerNameToOrder("");
      setCustomerID_ByWhichOrderListed(0);
    };

    // 2. Search type - Order
    const onSearch_SetCustomerObjAndOrderList = async () => {
      debugger;

      let customerAndOrderSearched;

      if (selectedSearchType === searchTypeEnum.ORDER) {
        console.log("Load Order search-------");
        customerAndOrderSearched = await customerServices.searchByOrderNumber(
          enteredSearchField
        );
      } else if (selectedSearchType === searchTypeEnum.TRACKING_NO) {
        console.log("Load Tracking No search-------");
        customerAndOrderSearched =
          await customerServices.searchByTrackingNumber(enteredSearchField);
      }

      // debugger;
      console.log(
        "searched customer and Order ----------> " +
          JSON.stringify(customerAndOrderSearched)
      );

      clearAllStateVariable();

      // a. set customer
      if (
        customerAndOrderSearched &&
        customerAndOrderSearched !== "undefined" &&
        customerAndOrderSearched !== null
      ) {
        // alert("inside ... done...");
        // debugger;
        dispatch(addCustomerInfo(customerAndOrderSearched.customer));
        setCustomerOrderList(customerAndOrderSearched.lstVmCustomerAndOrder);
        setCustomerNameToOrder(customerAndOrderSearched.customer.name);
        setCustomerID_ByWhichOrderListed(
          customerAndOrderSearched.customer.customerID_GUID
        );
      } else {
        dispatch(addCustomerInfo(null));
      }
    };

    // (2) clear setTime out
    return () => {
      console.log("clear timeout");
      clearTimeout(identifier);
    };
  }, [enteredSearchField, selectedSearchType]);

  // if (loading) return <h1> LOADING...</h1>;
  // if (error) console.log(error);

  //*************** Check Box */
  const [checkedCustomerGUID, setCheckedCustomerGUID] = useState(0);
  const handleOnCheckBoxChange = (cusGuid) => {
    // alert(cusGuid);
    setCheckedCustomerGUID(cusGuid);
  };

  //********************************** Add Customer */
  const [showAddCustomerPopup, setShowAddCustomerPopup] = useState(false);
  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  const AddCustomerPopup = () => {
    setShowAddCustomerPopup(true);
  };
  const AddCustomerToDB = (values) => {
    // alert("save it to DB from parent");
    console.log("values : " + values.Name);
    customerServices.save(values);
  };

  const isValidChildFormInputs = (values) => {
    // alert("isValidChildFormInputs at parent");
    console.log("isValidChildFormInputs value : " + values);
  };

  const submitFromModalParent = () => {
    //alert("now submit child");
    childSubmitButton.current.click();
    //this.refs.childComponent.getWrappedInstance().handleSubmit();
  };

  //***********************Redirect to Customer Measuremnt List page */
  const redirectToCustomerMeasurementList = function (customerGUID) {
    // console.log("doing something");
    const win = window.open(
      "/Customer/" + customerGUID + "/Measurement",
      "_blank"
    );
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };

  //***********************Redirect to Customer - add some  page */
  const redirectToAddNewPageForACustomer = function (
    customerGUID,
    redirectPage
  ) {
    if (customerGUID <= 0) {
      NotificationManager.warning("Please select one customer", "", 4000);
      return;
    }
    const win = window.open(
      "/Customer/" + customerGUID + "/" + redirectPage,
      "_blank"
    );
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };
  const redirectToNewPageAtNewTab = function (redirectPage) {
    const win = window.open("/" + redirectPage, "_blank");
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };

  //**  SEARCH OPTION DROPDOWN */
  const onSearchTypeChange = function (selectedSearchType) {};

  const handleOnFocusSearchField_Customer = (e) => {
    setSelectedSearchStyle_Customer(inputSearchStyle_selected);
    setSelectedSearchStyle_Order(inputSearchStyle_Notselected);
    setSelectedSearchStyle_TrackingNo(inputSearchStyle_Notselected);

    setSelectedSearchType(searchTypeEnum.CUSTOMER);
    setEnteredSearchField(e.target.value);
    console.log("search customer entered By: " + e.target.value);

    // document.getElementById("customerSearch").classList.add("inputBoxStyle");
    // document.getElementById("orderSearch").classList.remove("inputBoxStyle");
    // document
    //   .getElementById("trackingNoSearch")
    //   .classList.remove("inputBoxStyle");
    // console.log("hangle focus");
  };

  const handleOnFocusSearchField_Order = (e) => {
    setSelectedSearchStyle_Customer(inputSearchStyle_Notselected);
    setSelectedSearchStyle_Order(inputSearchStyle_selected);
    setSelectedSearchStyle_TrackingNo(inputSearchStyle_Notselected);

    setSelectedSearchType(searchTypeEnum.ORDER);
    setEnteredSearchField(e.target.value);
    console.log("search order entered By: " + e.target.value);

    // document.getElementById("customerSearch").classList.remove("inputBoxStyle");
    // document.getElementById("orderSearch").classList.add("inputBoxStyle");
    // document
    //   .getElementById("trackingNoSearch")
    //   .classList.remove("inputBoxStyle");
    // console.log("hangle focus");
  };

  const handleOnFocusSearchField_TrackingNo = (e) => {
    setSelectedSearchStyle_Customer(inputSearchStyle_Notselected);
    setSelectedSearchStyle_Order(inputSearchStyle_Notselected);
    setSelectedSearchStyle_TrackingNo(inputSearchStyle_selected);

    setSelectedSearchType(searchTypeEnum.TRACKING_NO);
    setEnteredSearchField(e.target.value);
    console.log("search tracking No entered By: " + e.target.value);

    // document.getElementById("customerSearch").classList.remove("inputBoxStyle");
    // document.getElementById("orderSearch").classList.remove("inputBoxStyle");
    // document.getElementById("trackingNoSearch").classList.add("inputBoxStyle");
    // console.log("hangle click");
  };

  const inputSearchStyle_selected = {
    // color: "blue",
    backgroundColor: "lightgray",
    marginRight: "10px",
  };

  const inputSearchStyle_Notselected = {
    marginRight: "10px",
  };

  function ShowSearchTitle() {
    if (selectedSearchType === searchTypeEnum.CUSTOMER) {
      return translation.search_by + " " + translation.Customer;
    } else if (selectedSearchType === searchTypeEnum.ORDER) {
      return translation.search_by + " " + translation.orderNumber;
    } else if (selectedSearchType === searchTypeEnum.TRACKING_NO) {
      return translation.search_by + " " + translation.trackingNumber;
    }
  }

  return (
    <Fragment>
      {/* ModalPopUp for customer add */}
      {showAddCustomerPopup && (
        <ModalForForms
          title="Add Customer"
          setShowAddCustomerPopup={setShowAddCustomerPopup}
          submitFromModalParent={submitFromModalParent}
        >
          <CustomerAdd
            isValidChildFormInputs={isValidChildFormInputs}
            AddCustomerToDB={AddCustomerToDB}
            ref={childSubmitButton}
          />{" "}
        </ModalForForms>
      )}

      <div style={{ clear: "both" }}></div>

      <div className="row">
        <div className="col-lg-4 margin0 padding3px">
          <div className="card padding5">
            <div className="card-body padding0">
              {/* Add New Order and Customer  */}
              <div className="" style={{ float: "right" }}>
                <button onClick={() => AddCustomerPopup()}>
                  <span className="badge badge-danger px-2">
                    {translation.add_new_customer}
                  </span>
                </button>
              </div>
              <div className="" style={{ marginBottom: "10px" }}>
                <button
                  onClick={() =>
                    redirectToNewPageAtNewTab("Customer/addnew/Order/addnew")
                  }
                >
                  <span className="badge badge-danger px-2">
                    {translation.add_new_order}
                  </span>
                </button>
              </div>

              <div style={{ clear: "both" }}></div>
              {/* <!-- Customer search Bar --> */}
              <div className="card-title margin0" style={{ float: "left" }}>
                <h4>
                  <ShowSearchTitle />({customerList.length})
                </h4>
                {loadingVar && <span>Loading...</span>}
              </div>
              {/* <!-- Add Measurement + Add Order button --> */}
              <div className="" style={{ float: "right" }}>
                <button
                  onClick={() =>
                    redirectToAddNewPageForACustomer(
                      checkedCustomerGUID,
                      "Order/AddNew"
                    )
                  }
                >
                  <span className="badge badge-danger px-2">
                    {translation.add_customer_order}
                  </span>
                </button>
              </div>
              <div className="" style={{ float: "right" }}>
                <button
                  onClick={() =>
                    redirectToAddNewPageForACustomer(
                      checkedCustomerGUID,
                      "Measurement/AddNew"
                    )
                  }
                >
                  <span className="badge badge-danger px-2">
                    {translation.add_customer_measurement}
                  </span>
                </button>
              </div>

              <div style={{ clear: "both" }}></div>
              <div className="" style={{ float: "right" }}>
                <button
                // onClick={() =>
                //   redirectToAddNewPageForACustomer(
                //     checkedCustomerGUID,
                //     "Order/AddNew"
                //   )
                // }
                >
                  <span className="badge badge-danger px-2">
                    {translation.view_order}
                  </span>
                </button>
              </div>
              <div className="" style={{ float: "right" }}>
                <button
                // onClick={() =>
                //   redirectToCustomerMeasurementList(
                //     cus.customerID_GUID
                //   )
                // }
                >
                  <span className="badge badge-danger px-2">
                    {translation.view_measurement}
                  </span>
                </button>
              </div>
              <div className="" style={{ float: "right" }}>
                <button onClick={() => AddCustomerPopup()}>
                  <span className="badge badge-danger px-2">
                    {translation.edit_customer}
                  </span>
                </button>
              </div>

              {/* Search Option */}
              <div className="input-group icons">
                {/* <DropdownFromEnum
                  style={{ width: "150px" }}
                  enumParam={searchTypeEnum}
                  setSelectedValue={setSelectedSearchType}
                  showDefaultOption={false}
                  defaultLabel={""}
                  defaultValue={""}
                /> */}

                <input
                  style={selectedSearchStyle_Customer}
                  id="customerSearch"
                  type="text"
                  className="form-control inputBoxStyle"
                  placeholder={translation.search_customers}
                  aria-label="Search Dashboard"
                  onChange={handleChangeOfSearchField}
                  onClick={handleOnFocusSearchField_Customer}
                  onFocus={handleOnFocusSearchField_Customer}
                ></input>

                <input
                  id="orderSearch"
                  style={selectedSearchStyle_Order}
                  type="text"
                  className="form-control"
                  placeholder={translation.search_orders}
                  aria-label="Search Dashboard"
                  onChange={handleChangeOfSearchField}
                  onClick={handleOnFocusSearchField_Order}
                  onFocus={handleOnFocusSearchField_Order}
                ></input>

                <input
                  id="trackingNoSearch"
                  style={selectedSearchStyle_TrackingNo}
                  type="text"
                  className="form-control"
                  placeholder={translation.search_trackingNo}
                  aria-label="Search Dashboard"
                  onChange={handleChangeOfSearchField}
                  onClick={handleOnFocusSearchField_TrackingNo}
                  onFocus={handleOnFocusSearchField_TrackingNo}
                ></input>
              </div>

              <div className="table-responsive, customerSearchDiv">
                {/* Show Customer Detail */}
                {(selectedSearchType === searchTypeEnum.ORDER ||
                  selectedSearchType === searchTypeEnum.TRACKING_NO) && (
                  <_CustomerDetailShow customer={customerStore} />
                )}

                {/* Show Customer List */}
                {selectedSearchType === searchTypeEnum.CUSTOMER && (
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{translation.si}</th>
                        <th>{translation.name}</th>
                        <th>{translation.phone}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {CodeTracking.showTrackingPosition(
                        "customer 2342343puupoupoiu"
                      )}
                      {customerList.map((cus, i) => (
                        <tr key={i}>
                          <th>
                            {" "}
                            <input
                              type="checkbox"
                              id={"custom-checkbox-${cus.customerID_GUID}"}
                              checked={
                                checkedCustomerGUID === cus.customerID_GUID
                                  ? true
                                  : false
                              }
                              onChange={() =>
                                handleOnCheckBoxChange(cus.customerID_GUID)
                              }
                            />
                          </th>
                          <th>{i + 1}</th>
                          <td>{cus.name}</td>
                          <td>{cus.cellNo}</td>
                          <td>
                            {CodeTracking.showTrackingApi(
                              "orderServices.getOrderVMByCustomerID"
                            )}
                            <button
                              onClick={() =>
                                LoadOrderByCustomerID(
                                  cus.customerID_GUID,
                                  cus.name
                                )
                              }
                            >
                              <span className="badge badge-danger px-2">
                                {translation.order}
                              </span>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /# column --> */}
        <div className="col-lg-8 margin0 padding3px">
          <div className="card padding5">
            <div className="card-body padding0">
              <div className="card-title">
                <h4>
                  {translation.order} (
                  {
                    customerOrderList
                      .map((item) => item.orderID_GUID)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      ).length
                  }
                  ) <br /> {translation.customer_name}:{" "}
                  {customerNameToOrder ? customerNameToOrder : ""}
                  {loadingOrderVar && <span>{translation.Loading}...</span>}
                </h4>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{translation.si}</th>
                      <th>{translation.order_date}</th>
                      <th>{translation.order_number}</th>
                      <th>{translation.delivery_date}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerOrderList
                      .map((item) => item.orderID_GUID)
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      )
                      .map((orderGUID, i) => (
                        <>
                          <OrderRow
                            indexno={i + 1}
                            orderGUID={orderGUID}
                            customerOrderList={customerOrderList}
                            LoadOrderByCustomerID={LoadOrderByCustomerID}
                            customerGUID={customerID_ByWhichOrderListed}
                          />
                          <tr>
                            <td colSpan="5">
                              {CodeTracking.showTrackingPosition(
                                "Order detail irpotweirpower0283-9429"
                              )}
                              <table
                                style={{ width: "100%" }}
                                className="table table-bordered"
                              >
                                <thead>
                                  <tr>
                                    <th>{translation.si}</th>
                                    <th>{translation.name}</th>
                                    <th>{translation.trackingNumber}</th>
                                    <th>{translation.qty}</th>
                                    <th style={{ width: "20%" }}>
                                      {translation.status}
                                    </th>
                                    <th style={{ width: "40%" }}>
                                      {translation.statusInfo}
                                    </th>
                                    <th>{translation.responsible}</th>
                                    <th>{translation.statusDate}</th>
                                    <th>{translation.note}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {customerOrderList
                                    .filter((o) => o.orderID_GUID === orderGUID)
                                    .map((orderDetail, i) => {
                                      return (
                                        <tr>
                                          <th>{i + 1}</th>
                                          <td>
                                            {orderDetail.name}
                                            {/* {orderDetail.orderDetailID_GUID} */}
                                          </td>
                                          <td>{orderDetail.orderDetailID}</td>
                                          <td>{orderDetail.qty}</td>
                                          <td>
                                            <span
                                              style={{
                                                background:
                                                  "#" + orderDetail.colorCode,
                                                padding: "4px",
                                              }}
                                              className="gradient-3 btn-rounded"
                                            >
                                              {orderDetail.workingStepName}
                                            </span>
                                          </td>
                                          <td>
                                            {orderDetail.additionalInfo}
                                            {orderDetail.additionalInfo !==
                                            "" ? (
                                              <>
                                                {" "}
                                                <br /> <br />
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {orderDetail.tailorName !== "" ? (
                                              <span
                                                style={{
                                                  background:
                                                    "#" + orderDetail.colorCode,
                                                  padding: "4px",
                                                }}
                                                className="gradient-3 btn-rounded"
                                              >
                                                {orderDetail.tailorName}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                          <td>
                                            {orderDetail.responsibleStuffName}
                                          </td>
                                          <td>
                                            {" "}
                                            {commonServices.showDateRemovedT(
                                              orderDetail.soDateTime
                                            )}
                                          </td>
                                          <td>{orderDetail.note}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CustomerList;
